import {initI18n, useEnvironment} from '@wix/yoshi-flow-editor';
import {useMemo} from 'react';

export function useICUI18n() {
  const {language} = useEnvironment();
  return useMemo(() => initI18n({locale: language, messages: {}}), [language]);
}
